import { Layout } from "@/components";
import { BookingCheck, BookingConfirm, Complete, CompleteMobile, Home, Payment, Reserve } from "@/domains";
import { MEDIA } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { createBrowserRouter, Navigate } from "react-router-dom";

const router = () => {
    const { isTablet } = MEDIA();
    const defaultParams = new URLSearchParams(getDefaultParameters());

    return createBrowserRouter(
        [
            {
                path: "/",
                element: <Layout />,
                children: [
                    {
                        path: "/",
                        element: (
                            <Navigate
                                to={
                                    isTablet
                                        ? `/reserve?${defaultParams.toString()}`
                                        : `/status?${defaultParams.toString()}`
                                }
                                replace
                            />
                        ),
                    },
                    {
                        path: "/status",
                        element: <Home />,
                    },
                    {
                        path: "/reserve",
                        element: <Reserve />,
                    },
                    {
                        path: "/payment",
                        element: <Payment />,
                    },
                    {
                        path: "/bookingCheck",
                        element: <BookingCheck />,
                    },
                    {
                        path: "/complete",
                        element: <Complete />,
                    },
                    {
                        path: "/completeMobile",
                        element: <CompleteMobile />,
                    },
                    {
                        path: "/bookingConfirm",
                        element: <BookingConfirm />,
                    },
                ],
            },
        ],
        { basename: "/calendar" },
    );
};

export default router;
